// =====================================
//
//   Point 月結相關功能 Service
//   Author: Gray
//   createtime: 2018 / 04 / 24
//
// =====================================
window.InifECShared.factory("PointsMonthlyService", ['$q', '$http', function($q, $http) {

    var factory = {};

    // --------------------------------
    // 取得最新的月結繳款單
    // --------------------------------
    var getLastPointsMonthlyPayment = function() {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/PointsMonthlyPaymentAction.do",
            method: "GET",
            params: {
                op: "getLastPointsMonthlyPayment",
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointsMonthlyService.getLastPointsMonthlyPayment request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }
  	
  	// --------------------------------
    // 使用月結繳款單建立點數加值交易
    // --------------------------------
    var payPointsMonthlyPayment = function(addressInfo) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/PointsMonthlyPaymentAction.do",
            method: "POST",
            data: $.param({
                op: "payPointsMonthlyPayment",
                addressInfo: addressInfo,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointsMonthlyService.payPointsMonthlyPayment request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得某筆的月結繳款單
    // --------------------------------
    var getPointsMonthlyPayment = function(monthlypaymentid) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/PointsMonthlyPaymentAction.do",
            method: "GET",
            params: {
                op: "getPointsMonthlyPayment",
                monthlypaymentid: monthlypaymentid,
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointsMonthlyService.getPointsMonthlyPayment request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得月結繳款單列表
    // --------------------------------
    var getPointsMonthlyPaymentList = function(start, len) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/PointsMonthlyPaymentAction.do",
            method: "GET",
            params: {
                op: "getPointsMonthlyPaymentList",
                start: start,
                len: len,
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointsMonthlyService.getPointsMonthlyPaymentList request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得某筆的月結繳款單
    // --------------------------------
    var getPointsMonthlyPaymentConsumelog = function(monthlypaymentid) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/PointsMonthlyPaymentAction.do",
            method: "GET",
            params: {
                op: "getPointsMonthlyPaymentConsumelog",
                monthlypaymentid: monthlypaymentid,
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointsMonthlyService.getPointsMonthlyPaymentConsumelog request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

	/*==========================
        Methods
    ==========================*/
    // 取得最新的月結繳款單
    factory.getLastPointsMonthlyPayment = getLastPointsMonthlyPayment;
    // 使用月結繳款單建立點數加值交易
    factory.payPointsMonthlyPayment = payPointsMonthlyPayment;    
    // 取得某筆的月結繳款單
    factory.getPointsMonthlyPayment = getPointsMonthlyPayment;
    // 取得月結繳款單列表
    factory.getPointsMonthlyPaymentList = getPointsMonthlyPaymentList;
    // 取得某筆的月結繳款單
    factory.getPointsMonthlyPaymentConsumelog = getPointsMonthlyPaymentConsumelog;
    
    return factory;
}]);